// src/authConfig.js
export const msalConfig = {
    auth: {
//TODO: remvoe hardcoded values for dev/prod deployment
      clientId: process.env.REACT_APP_CLIENT_ID, 
      authority: process.env.REACT_APP_AUTHORITY,
      redirectUri: window.location.origin,  
    },
    cache: {
      cacheLocation: "sessionStorage",  // Can be sessionStorage or localStorage
      storeAuthStateInCookie: false,  // Set to true to store authentication state in cookies for older browsers
    },
    system: {
      loggerOptions: {
        logLevel: "info",  // Can be 'verbose' for more detailed logging
        piiLoggingEnabled: false,  // Enable only for debugging
      },
    },
  };
  
  export const loginRequest = {
    scopes: ["openid", "profile", "User.Read"],  // Define your scopes, for example User.Read to read user data
  };
  
